import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdobeLaunchService } from "../shared/services/adobe-launch.service";
import { PAGE_TITLES, resolveSupportedLang } from '../shared/config/localized-paths';

@Component({
  selector: 'overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit, OnDestroy {

  private keydownListener: (event: KeyboardEvent) => void;

    constructor(
        private readonly adobeLaunchService: AdobeLaunchService,
        private readonly translateService: TranslateService,
    ) {
      this.keydownListener = this.handleKeydown.bind(this);
    }

  ngOnInit(): void {
    const lang = resolveSupportedLang(this.translateService.currentLang);
    this.adobeLaunchService.trackPageView({
      pageTitle: PAGE_TITLES[lang].overview,
    });

    document.addEventListener('keydown', this.keydownListener);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.keydownListener);
  }

  private handleKeydown(event: KeyboardEvent): void {
    if (event.shiftKey && event.key === 'Tab') {
      const focusedElement = document.activeElement;
      if (focusedElement) {
        focusedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }
}
